module.exports = __webpack_public_path__ + "img/dzbp_summary_Image.9e820812.png";